
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/combo",
      function () {
        return require("private-next-pages/combo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/combo"])
      });
    }
  